import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../theme/ThemeProvider';
import FallingStarLogo from '../theme/FallingStarLogo';

export default function Footer() {
  const { t } = useTheme();

  const colTitle = { fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: t.textFaint, marginBottom: 14 };
  const link = { display: 'block', fontSize: 13, color: t.textMuted, marginBottom: 10, transition: 'color 0.2s' };

  return (
    <footer style={{ borderTop: `1px solid ${t.divider}`, padding: '48px 24px 32px', marginTop: 80, position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 48, marginBottom: 40 }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
              <FallingStarLogo size={24} />
              <span className="iri-text" style={{ fontSize: 16, fontWeight: 800 }}>xceller.</span>
            </div>
            <p style={{ fontSize: 13, color: t.textDim, lineHeight: 1.6, maxWidth: 300 }}>
              Automated signal trading from Telegram to MetaTrader 5.
            </p>
          </div>

          {/* Links */}
          <div>
            <div style={colTitle}>Product</div>
            <Link to="/" style={link}>Home</Link>
            <Link to="/about" style={link}>About</Link>
            <Link to="/pricing" style={link}>Pricing</Link>
            <Link to="/dashboard" style={link}>Dashboard</Link>
          </div>

          {/* Legal */}
          <div>
            <div style={colTitle}>Legal</div>
            <span style={{ ...link, opacity: 0.4, cursor: 'default', fontSize: 12 }}>Terms of Service — coming soon</span>
            <span style={{ ...link, opacity: 0.4, cursor: 'default', fontSize: 12 }}>Privacy Policy — coming soon</span>
            <span style={{
              display: 'block', fontSize: 11, color: t.textFaint, marginTop: 8,
              padding: '8px 12px', borderRadius: 8,
              background: t.sectionBg, border: `1px solid ${t.sectionBorder}`,
              lineHeight: 1.5,
            }}>
              xceller. is a tool, not a financial advisor. Trading involves risk. Past performance does not guarantee future results.
            </span>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: `1px solid ${t.divider}`, paddingTop: 20, textAlign: 'center' }}>
          <span style={{ fontSize: 12, color: t.textFaint }}>2026 xceller. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
